module.exports = __webpack_public_path__ + "img/grade-report.037fec48.svg";